import React, { type ReactNode, useCallback, useState } from 'react'
import { Button } from '../../../components/Button/Button'

interface CredentialFieldProps {
  label: string
  value: string
  copyable?: boolean
  action?: ReactNode
  valueIcon?: ReactNode
}

export const CredentialField: React.FC<CredentialFieldProps> = ({ label, value, copyable, action, valueIcon }) => {
  const [copied, setCopied] = useState<boolean>(false)

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }, [value])

  return (
    <div className='border rounded p-3 d-flex justify-content-between align-items-center'>
      <div className='overflow-hidden'>
        <div className='small text-muted'>{label}</div>
        <span className='text-break text-secondary d-inline-flex align-items-center gap-1'>
          {valueIcon}
          {value}
        </span>
      </div>
      {copyable ? (
        <Button variant='secondaryGhostButton' onClick={handleCopy} className='d-flex align-items-center gap-1 ms-2 flex-shrink-0'>
          <i className={copied ? 'bi bi-clipboard-check' : 'bi bi-clipboard'} />
          {copied ? 'Copied' : 'Copy'}
        </Button>
      ) : null}
      {action ?? null}
    </div>
  )
}
